module.exports = __webpack_public_path__ + "static/media/r.f11169f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/starPilots/r.png
// module id = 830
// module chunks = 0